import React from 'react';

import { createStyles, Icon, withStyles, WithStyles } from '@material-ui/core';

// TODO sanitize LegendListNodes styles
const styles = () =>
  createStyles({
    icon: {
      fontSize: 11,
      fontWeight: 600,
      paddingTop: 2,
    },
    legend: {
      display: 'inline-block',
      float: 'right',
      padding: '0px 8px',
      whiteSpace: 'nowrap',
    },
    search: {
      display: 'inline-block',
      float: 'left',
      whiteSpace: 'nowrap',
    },
    term: {
      display: 'inline-block',
      float: 'left',
      maxWidth: 94,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    wrapper: {
      backgroundColor: '#eaeaea',
      color: '#585858',
      display: 'inline-block',
      float: 'left',
      fontSize: 11,
      fontWeight: 400,
      padding: 8,
      width: '100%',
    },
  });

export interface LegendListNodesProps extends WithStyles<typeof styles> {
  query: string;
}

const LegendListNodes: React.FC<LegendListNodesProps> = ({ classes, query }) => (
  <div className={classes.wrapper}>
    <div className={classes.search}>matching &quot;@</div>
    <div className={classes.term}>{query}</div>
    <div className={classes.search}>&quot;</div>
    <div className={classes.legend}>
      <b style={{ fontWeight: 600 }}>esc</b> to dismiss
    </div>
    <div className={classes.legend}>
      <b style={{ fontWeight: 600 }}>tab</b> or <Icon className={classes.icon}>keyboard_return</Icon> to select
    </div>
    <div className={classes.legend}>
      <Icon className={classes.icon}>arrow_upward</Icon>
      <Icon className={classes.icon}>arrow_downward</Icon>
    </div>
  </div>
);

export default withStyles(styles)(LegendListNodes);
